import { PersonaType } from '~/tenants/common/TenantPersona';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { format_money } from '~/components/Money';
import Big from 'big.js';
import { TWT_PHOTO_EXTRA } from '~/tenants/twt/performable/photo/TwtPhotoJob';
import { TenantPackageAddOnGeneric } from '~/tenants/common/package';
import React from 'react';

export default function TwtPhotosExtra({ persona }: { persona: PersonaType }) {
  return (
    <TenantPackageAddOnGeneric
      title="Extra Photos"
      image="tenant/twt/residential/1.jpg"
      persona={persona}
      description="Need more photos?"
    >
      <ZodFieldSelect
        options={[
          { label: 'No Extra Photos', value: '0' },
          {
            label: `5 Extra Photos: ${format_money(new Big(TWT_PHOTO_EXTRA).times(1).toFixed(2))}`,
            value: '5',
          },
          {
            label: `10 Extra Photos: ${format_money(new Big(TWT_PHOTO_EXTRA).times(2).toFixed(2))}`,
            value: '10',
          },
          {
            label: `15 Extra Photos: ${format_money(new Big(TWT_PHOTO_EXTRA).times(3).toFixed(2))}`,
            value: '15',
          },
          {
            label: `20 Extra Photos: ${format_money(new Big(TWT_PHOTO_EXTRA).times(4).toFixed(2))} `,
            value: '20',
          },
          {
            label: `25 Extra Photos: ${format_money(new Big(TWT_PHOTO_EXTRA).times(5).toFixed(2))} `,
            value: '25',
          },
        ]}
        name="photos"
      />
    </TenantPackageAddOnGeneric>
  );
}
